import update from 'immutability-helper';
import {SET_NEW_SHOPPINGCART} from './shoppingCartReducer.js';
import {LEO_THEME} from "../dev";
import sponsorApi from "../lib/api/sponsors";

export const initialState = {
    sponsorCodesEnabled: false,
    codeUsagesPlUuidMap: {},
    seatReservations: [],
    freeSeatReservations: [],
    sponsorCodes: [],
    excludePublicSeats: false,
    entranceUrl: null,
    partnerShopFailed: false,
    partnershopErrors: []
};

// ------------------------------------
// Constants
// ------------------------------------
export const SET_SPONSOR_CODES_ENABLED = 'SPONSOR_CODES/SET_SPONSOR_CODES_ENABLED';
export const SET_CODE_USAGES_PLUUIDS_MAP = 'SPONSOR_CODES/SET_CODE_USAGES_PLUUIDS_MAP';
export const SET_CODES = 'SPONSOR_CODES/SET_CODES';
export const SET_CODES_AND_PL_MAP = 'SPONSOR_CODES/SET_CODES_AND_PL_MAP';
export const SET_CODES_AND_PL_MAP_EXCLUSIVE = 'SPONSOR_CODES/SET_CODES_AND_PL_MAP_EXCLUSIVE';
export const SET_SPONSOR_RESERVATIONS = 'SPONSOR_CODES/SET_SPONSOR_RESERVATIONS';
export const RESET = 'SPONSOR_CODES/RESET';
export const SET_ENTRANCE_URL = 'SPONSOR_CODES/SET_ENTRANCE_URL';
export const PARTNERSHOP_FAILED = 'SPONSOR_CODES/PARTNERSHOP_FAILED';
export const SET_PARTNERSHOP_ERRORS = "SPONSOR_CODES/SET_PARTNERSHOP_ERRORS";

export function setSponsorCodesEnabled(sponsorCodesEnabled) {
    return {
        type: SET_SPONSOR_CODES_ENABLED,
        sponsorCodesEnabled,
    };
}

export function setCodeUsagesPlUuidMap(codeUsagesPlUuidMap) {
    return {
        type: SET_CODE_USAGES_PLUUIDS_MAP,
        codeUsagesPlUuidMap,
    };
}

export function setCodes(codes) {
    return {
        type: SET_CODES,
        codes,
    };
}

export function setCodesAndPlMap(codes, codeUsagesPlUuidMap) {
    return {
        type: SET_CODES_AND_PL_MAP,
        codes,
        codeUsagesPlUuidMap
    };
}

export function setCodesAndPlMapExclusive(codes, codeUsagesPlUuidMap, entranceUrl) {
    return {
        type: SET_CODES_AND_PL_MAP_EXCLUSIVE,
        codes,
        codeUsagesPlUuidMap,
        excludePublicSeats: true,
        entranceUrl: entranceUrl
    };
}

export function setSponsorReservations(reservations) {
    return {
        type: SET_SPONSOR_RESERVATIONS,
        reservations,
    };
}

export function fetchSponsorReservationsState() {
    return async (dispatch, getState) => {
        const reservationsState = await sponsorApi
            .getSponsorReservationSeats(
                getState().merchant.merchantId,
                getState().merchant.themeName,
                getState().event.selected);
        dispatch(setSponsorReservations(reservationsState));
    };
}

export function reset() {
    return {
        type: RESET
    };
}

export function setEntranceUrl(entranceUrl) {
    return {
        type: SET_ENTRANCE_URL,
        entranceUrl: entranceUrl
    };
}

export function setPartnershopFailed() {
    return {
        type: PARTNERSHOP_FAILED
    };
}

export function setPartnershopErrors(errors) {
    return {
        type: SET_PARTNERSHOP_ERRORS,
        errors: errors
    };
}

// -------------------
// Action Creators
// -------------------
export function loadSponsorCodesConfig() {
    const sponsorCodesDisabledValue = (LEO_THEME.modules['sponsor-codes'] && LEO_THEME.modules['sponsor-codes']['sponsor-codes-disabled'])
        ? LEO_THEME.modules['sponsor-codes']['sponsor-codes-disabled'] : '';
    const sponsorCodesEnabled = !(sponsorCodesDisabledValue === 'true');
    return (dispatch) => {
        if (!sponsorCodesEnabled) {
            return Promise.resolve();
        }
        return dispatch(setSponsorCodesEnabled(sponsorCodesEnabled));
    };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
    [SET_SPONSOR_CODES_ENABLED]: (state, action) => update(state, {
        sponsorCodesEnabled: {$set: action.sponsorCodesEnabled},
    }),
    [SET_CODE_USAGES_PLUUIDS_MAP]: (state, action) => update(state, {
        codeUsagesPlUuidMap: {$set: action.codeUsagesPlUuidMap},
    }),
    [SET_CODES]: (state, action) => update(state, {
        sponsorCodes: {$set: action.codes},
    }),
    [SET_CODE_USAGES_PLUUIDS_MAP]: (state, action) => update(state, {
        codeUsagesPlUuidMap: {$set: action.codeUsagesPlUuidMap},
    }),
    [SET_CODES_AND_PL_MAP]: (state, action) => update(state, {
        sponsorCodes: {$set: action.codes},
        codeUsagesPlUuidMap: {$set: action.codeUsagesPlUuidMap},
    }),
    [SET_CODES_AND_PL_MAP_EXCLUSIVE]: (state, action) => update(state, {
        sponsorCodes: {$set: action.codes},
        codeUsagesPlUuidMap: {$set: action.codeUsagesPlUuidMap},
        excludePublicSeats: {$set: action.excludePublicSeats},
        entranceUrl: {$set: action.entranceUrl},
    }),
    [SET_SPONSOR_RESERVATIONS]: (state, action) => update(state, {
        seatReservations: {$set: action.reservations.seats},
        freeSeatReservations: {$set: action.reservations.freeSeatings}
    }),
    // basically resetting the codes if "session has ended" (new Shoppingcart)
    [SET_NEW_SHOPPINGCART]: (state) => {
        if (state.excludePublicSeats) {
            return state;
        } else {
            const { sponsorCodesEnabled, seatReservations, freeSeatReservations } = state;

            return {
                ...initialState,
                sponsorCodesEnabled,
                seatReservations,
                freeSeatReservations
            };
        }
    },
    [SET_ENTRANCE_URL]: (state, action) => update(state, {
        entranceUrl: {$set: action.entranceUrl},
    }),
    [PARTNERSHOP_FAILED]: (state) => update(state, {
        partnerShopFailed: {$set: true},
    }),
    [SET_PARTNERSHOP_ERRORS]: (state, action) => update(state, {
        partnershopErrors: {$set: action.errors},
    }),
    [RESET]: () => initialState,
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function reducerFunction(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
}
